<div class="mainHeader__userAccess tabActiveOn">
  <!-- home mobile -->
  <div class="userAccess__item userAccess__item--home">
    <a
      routerLink="/"
      [routerLinkActiveOptions]="{exact: true}"
      routerLinkActive="tabActive"
      class="userAccess__item__icon"
      (click)="trackHeaderButtonClick('home')"
    >
      <vc-sprite-icons
        class="userAccess__item__icon__svg d-lg-none userAccess__item__icon__svg--full"
        name="home-full"
      ></vc-sprite-icons>
      <vc-sprite-icons
        class="userAccess__item__icon__svg d-lg-none userAccess__item__icon__svg--line"
        name="home-line"
      ></vc-sprite-icons>
      <span class="d-lg-none userAccess__item__icon__title"> Home </span>
    </a>
  </div>

  <!-- feed mobile + desktop // use feature flag -->
  <div *ngIf="isFeedEnabled" class="userAccess__item userAccess__item--feed d-lg-none">
    <!-- as seen with Geoffroy it's a little trick to be able to keep the final slash -->
    <vc-ref
      [resource]="'/feed/.'"
      [anchor]="false"
      [extraClass]="this.url && this.url.includes('feed') ? 'tabActive' : ''"
      class="userAccess__item__icon"
      (clicked)="trackHeaderButtonClick('newsfeed')"
    >
      <vc-sprite-icons
        class="userAccess__item__icon__svg userAccess__item__icon__svg--full"
        name="feed-full"
      ></vc-sprite-icons>
      <vc-sprite-icons
        class="userAccess__item__icon__svg userAccess__item__icon__svg--line"
        name="feed-line"
      ></vc-sprite-icons>
      <span class="userAccess__item__icon__title" i18n="@@HEADER.NAVIGATION.FEED_TITLE">Feed</span>
    </vc-ref>
  </div>

  <!-- This part of the menu MUST be removed after the full release of the newsfeed -->
  <div *ngIf="!isFeedEnabled" class="userAccess__item userAccess__item--feed d-lg-none">
    <button class="userAccess__item__icon" (click)="openMainNav.emit()">
      <vc-sprite-icons
        class="userAccess__item__icon__svg userAccess__item__icon__svg--line"
        name="search"
      ></vc-sprite-icons>
      <span class="userAccess__item__icon__title" i18n="@@HEADER.NAVIGATION.BUY_TITLE">Buy</span>
    </button>
  </div>

  <!-- sell mobile + desktop -->
  <div class="userAccess__item userAccess__item--sell">
    <vc-ref
      [anchor]="false"
      i18n-resource="@@LINKS.SELL_ONLINE"
      class="userAccess__item__icon"
      resource="/sell-clothes-online.shtml"
      (clicked)="trackHeaderButtonClick('sell now')"
    >
      <vc-sprite-icons class="userAccess__item__icon__svg d-lg-none" name="sell-line"></vc-sprite-icons>
      <div
        class=" userAccess__item__icon__cta vc-btn vc-btn--primary vc-btn--small"
        i18n="@@HEADER.SELL_AN_ITEM_BUTTON"
      >
        Sell an item
      </div>
      <span class="d-lg-none userAccess__item__icon__title" i18n="@@HEADER.NAVIGATION.SELL_TITLE"> Sell an item</span>
    </vc-ref>
  </div>

  <!-- notification mobile + desktop -->
  <div
    class="userAccess__item userAccess__item--notif"
    [ngClass]="{'d-lg-none': !isLogged, 'userAccess__item--active': boxes?.isNotifPreviewOpened}"
  >
    <button
      class="userAccess__item__icon"
      aria-labelledby="userAccess__item__icon__title--notif"
      (click)="
        $event.stopPropagation();
        trackHeaderButtonClick('notifications');
        togglePreviewBox('isNotifPreviewOpened', boxes?.isNotifPreviewOpened ? false : true, 'notif', true)
      "
    >
      <span
        *ngIf="
          headerBadgeDetail?.notificationCount > 0 && headerBadgeDetail?.notificationCount <= 99;
          else notifLineCountMore
        "
        class="userAccess__item__icon__count icon__count"
      >
        {{ headerBadgeDetail?.notificationCount }}
      </span>
      <ng-template #notifLineCountMore
        ><span class="userAccess__item__icon__count icon__count" *ngIf="headerBadgeDetail?.notificationCount">99+</span>
      </ng-template>
      <vc-sprite-icons
        class="userAccess__item__icon__svg userAccess__item__icon__svg--line"
        name="bell-line"
      ></vc-sprite-icons>
      <vc-sprite-icons
        class="userAccess__item__icon__svg userAccess__item__icon__svg--full"
        name="bell-full"
      ></vc-sprite-icons>
      <span
        class="userAccess__item__icon__title"
        id="userAccess__item__icon__title--notif"
        i18n="@@HEADER.NAVIGATION.NOTIFICATION_TITLE"
        >Notifications</span
      >
    </button>
    <vc-preview-box
      (resetBox)="closeBoxes($event)"
      *ngIf="isLogged"
      [isActive]="boxes?.isNotifPreviewOpened"
      i18n-title="@@HEADER.PREVIEW_BOX.NOTIFICATION_TITLE"
      title="Notifications"
      [right_pos]="previewBox__notif_right_pos"
    >
      <vc-notifications
        [isShow]="boxes?.isNotifPreviewOpened"
        (onClosePreviewBox)="togglePreviewBox('isNotifPreviewOpened', false, 'notif', true)"
      ></vc-notifications>
    </vc-preview-box>
  </div>

  <!-- profile mobile + desktop -->
  <div
    class="userAccess__item userAccess__item--profile"
    [ngClass]="{'d-lg-none': !isLogged, 'userAccess__item--active': boxes?.isProfilePreviewOpened}"
  >
    <button
      class="userAccess__item__icon userAccess__item__icon--profile"
      aria-labelledby="userAccess__item__icon__title--profile"
      (click)="
        $event.stopPropagation();
        trackHeaderButtonClick('me');
        togglePreviewBox('isProfilePreviewOpened', boxes?.isProfilePreviewOpened ? false : true, 'profile', true)
      "
    >
      <span
        *ngIf="needGetPaidAction && !boxes?.isProfilePreviewOpened"
        class="userAccess__item__icon__count icon__count userAccess__item__icon__count--me"
        >0
      </span>
      <img
        *ngIf="userInfo?.picture?.path"
        class="d-none d-lg-block"
        [src]="getImage(userInfo?.picture?.path)"
        alt="{{ userInfo?.firstname | slice: 0:1 }}"
      />
      <vc-sprite-icons
        class="d-lg-none userAccess__item__icon__svg userAccess__item__icon__svg--line"
        name="user-line"
      ></vc-sprite-icons>
      <vc-sprite-icons
        class="d-lg-none userAccess__item__icon__svg userAccess__item__icon__svg--full"
        name="user-full"
      ></vc-sprite-icons>
      <span
        class="userAccess__item__icon__title"
        id="userAccess__item__icon__title--profile"
        i18n="@@HEADER.NAVIGATION.ACCOUNT_TITLE"
        >Me</span
      >
    </button>
    <vc-preview-box
      (resetBox)="closeBoxes($event)"
      [isActive]="boxes?.isProfilePreviewOpened"
      [width]="290"
      [right_pos]="previewBox__profile_right_pos"
    >
      <vc-profile-access
        (resetBox)="closeBoxes($event)"
        [userInfo]="userInfo"
        [userWallet]="userWallet"
        [needGetPaidAction]="needGetPaidAction"
      ></vc-profile-access>
    </vc-preview-box>
  </div>

  <!-- connexion -->
  <div *ngIf="!isLogged" class="userAccess__item userAccess__item--connect d-none d-lg-block">
    <vc-auth-button type="login" i18n="@@HEADER.CONNECT_BUTTON">Sign in</vc-auth-button>
  </div>

  <div *ngIf="!isLogged" class="userAccess__item userAccess__item--connect d-none d-lg-block">
    <vc-auth-button type="register" i18n="@@HEADER.SUBSCRIBE_BUTTON">Sign up</vc-auth-button>
  </div>
</div>
